
export type GetHashtagsParams = {
query?: string;
limit?: number;
};
